import { useTranslations } from '@vocab/react';
import {
  Box,
  Card,
  Columns,
  Column,
  Stack,
  ButtonIcon,
  IconEdit,
  Drawer,
  Text,
} from 'braid-design-system';
import { useState } from 'react';

import { LoadingItem } from 'src/components/LoadingItem/LoadingItem';
import translations from 'src/components/Visibility/ProfileVisibility/.vocab';
import { useAnalytics } from 'src/contexts/AnalyticsContext';
import { useGetProfileVisibility } from 'src/modules/graphql/visibility/data';

import { EditApproachabilitySettings } from './EditApproachabilitySettings';
import { EditProfileVisibilitySettings } from './EditProfileVisibilitySettings';

export const ProfileVisibility = () => {
  const { t } = useTranslations(translations);
  const { trackProfileCardOpened } = useAnalytics();

  const {
    profileVisibilityLevel,
    profileVisibilityDescription,
    loading: profileVisibilityLoading,
  } = useGetProfileVisibility();

  const [drawerOpened, setDrawerOpened] = useState(false);

  const toggle = () => {
    if (drawerOpened === false) {
      trackProfileCardOpened({
        currentPageSubsection: 'employer site',
      });
    }
    setDrawerOpened((currentState) => !currentState);
  };

  return (
    <Box data-testid="profile-visibility-card">
      <Card rounded>
        <Columns space="small">
          <Column>
            <Stack space="medium">
              <Text weight="strong">{t('Searchable by employers')}</Text>
              {profileVisibilityLoading ? (
                <LoadingItem size="standard" width="small" />
              ) : (
                <Text tone="secondary">
                  {profileVisibilityDescription || t('Visibility not set')}
                </Text>
              )}
            </Stack>
          </Column>
          <Column width="content">
            <ButtonIcon
              id="editProfileVisibilityButton"
              variant="transparent"
              icon={<IconEdit />}
              label={t('Edit visibility')}
              onClick={toggle}
            />
          </Column>
        </Columns>
      </Card>
      <Drawer
        id="profileVisibilityDrawer"
        title={t('Searchable by employers')}
        open={drawerOpened === true}
        onClose={toggle}
        width="small"
        description={
          <Text>{t('Your profile visibility setting controls...')}</Text>
        }
      >
        <Stack space="large">
          <Stack space="xlarge">
            <EditProfileVisibilitySettings />
            {profileVisibilityLevel === 'Standard' ||
            profileVisibilityLevel === 'Limited' ? (
              <EditApproachabilitySettings />
            ) : null}
          </Stack>
        </Stack>
      </Drawer>
    </Box>
  );
};
